import React, { forwardRef } from 'react';
import { SubSectionContainer } from './subSectionContainer';

export const SubSection = forwardRef<HTMLDivElement, { children: React.ReactNode; className?: string; id?: string }>(({ children, className, id }, ref) => {
    return (
        <SubSectionContainer ref={ref} className={className} id={id}>
            {children}
        </SubSectionContainer>
    );
});
